import { initSplide } from '../../shared/init-splide';

initSplide('.wp-block-knightowl-blocks-slider');
